import { useChatStore, useCoworkerStore } from '@/store';

export function useCanShareChat(conversationId) {
  const chat = useChatStore(state => state.chats.find(c => c.id === conversationId));
  const hasProjectTask = useCoworkerStore(state => Object.values(state.tasks).some(task => {
    if (!task.localProject?.bindingId) return false;
    const linkedConversation = task.conversationId || task.conversation;
    const linkedTask = chat?.coworkerSession;
    return (linkedConversation && String(linkedConversation) === String(conversationId))
      || (linkedTask && String(linkedTask.id || linkedTask._id || linkedTask) === String(task.id));
  }));

  // Keep project transcripts private even after folder access is disconnected.
  // The task covers newly loaded chats before list classification is available.
  return !chat?.hasMacProject && !hasProjectTask;
}
